import { View } from "@/components/ui/view";
import React, { useState, useContext } from "react";
import i18n from "i18n-js";
import { useDispatch } from "react-redux";
import FloatingLabelInput from "@/components/basic/FloatingLabelInput";
import { GlobalState } from "@/containers/GlobalState";
import { processWorkflow } from "@/stores/thunks";
import ModalFrame from "@/components/basic/ModalFrame";

export default function ModalImport({ showModal, setShowModal }) {

    const dispatch = useDispatch()
    const { guid7 } = useContext(GlobalState)
    let [msg, setMsg] = useState('import.hint');
    let [info, setInfo] = useState('');

    const processJSON = () => {
        const data = info.trim()
        if (data.startsWith('[')) {
            // Assumption JSON string
            try {
                const json = JSON.parse(data)
                let task = { owned: true, title: json[0].text, text: i18n.t('itemInput.text'), step: -1, id: guid7(), media: [], steps: [] }
                json.unshift()
                task.steps = json.map(item => {
                    return { title: item.text, text: i18n.t('itemInput.text'), media: [], type: 0 }
                })
                console.log(task)
                dispatch(processWorkflow(task))
                navigation.goBack()
            } catch (error) {
                setMsg('' + error)
            }
        } else {
            // Assumption Text string
            const text = data.match(/[^\r\n]+/g);
            let task = { owned: true, title: text[0], text: i18n.t('itemInput.text'), step: -1, id: guid7(), media: [], steps: [] }
            text.unshift()
            task.steps = text.map(item => {
                return { title: item, text: i18n.t('itemInput.text'), media: [], type: 0 }
            })
            dispatch(processWorkflow(task))
            navigation.goBack()
        }
    }

    const onClose = (isOk) => {
        setShowModal(false)
        if (isOk) {
            processJSON()
        }
    }

    return (
        <ModalFrame title='import.title' text={msg} showModal={showModal} onClose={onClose}>
            <View className="w-[100%]">
                <FloatingLabelInput label={i18n.t('import.description')} h='h-[300px]' multiline={true} returnKeyType='done' blurOnSubmit={true} onChangeText={setInfo} value={info} />
            </View>
        </ModalFrame>
    );
}
